import React from 'react'
import '../styles/index.scss'
import ItemReproductionPage from "./ItemReproductionPage"

function ItemReproductionContainer() {
    return (
        <div className="BatchReproductionContainer">
            <ItemReproductionPage/>
        </div>
    )
}

export default ItemReproductionContainer
